






































import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import moment from 'moment'
import { detect, BrowserName } from 'detect-browser'
import semver from 'semver'

import SectionBase from '@/mixins/SectionBase'
import { Field } from '@/model/Field'
import OrderSectionBase from './OrderSectionBase'
import { ORDER_NAMESPACE } from '@/store/mod/order_form'

@Component({
  mixins: [SectionBase, OrderSectionBase],
})
export default class SectionAttachments extends OrderSectionBase {
  browser: null | {
      name: BrowserName | "node";
      version: string;
      os: string;
  } = null;

  get attachmentValidation (): string {
    // vee-validate says that size is set as kilobytes, but size:5000 will mean about 4.88MB. Since they
    // will use 1 kilobyte=1024 bytes, not 1000(as SI wants us to). Windows also says 1 kilobyte = 1024 bytes.
    // We set the max-size on the backend to be 5 Mebibyte, which means 5120 here
    const size = 'size:5120'

    if (this.browser && this.browser.name === 'ie' && semver.satisfies(this.browser.version, '10.x')) {
      return `ext:pdf,png,jpg,jpeg|${size}`
    } else {
      return `mimes:application/pdf,image/png,image/jpeg|${size}`
    }
  }

  get perspectiveRequirement (): string {
    const offerNum = this.value("offer_num")
    if (typeof offerNum === 'boolean') {
      throw new Error('"offer_num" can not be boolean')
    }

    if (offerNum === undefined || offerNum.length === 0) {
      return this.requiredAttachment
    } else {
      return this.attachmentValidation
    }
  }

  get requiredAttachment (): string {
    return `required|${this.attachmentValidation}`
  }

  changeAttachment (name: string, file: File) {
    this.$store.commit(`${ORDER_NAMESPACE}/setAttachment`, { name, file })
  }

  created () {
    this.browser = detect()
  }
}
